import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { TestimonialPayload } from '../types';

export const fetchTestimonials = async (): Promise<TestimonialPayload[]> => {
  const response = await fetch(API_ENDPOINTS.testimonials, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Testimonials request failed with status ${response.status}`);
  }

  const data: TestimonialPayload[] = await response.json();
  return Array.isArray(data) ? data : [];
};

